import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuthContext } from "Context/authContext";
import subscriptionService from "services/subscriptionService";
import Button from "components/molecules/Button";

const asDate = (value) => {
  if (!value) return null;
  // Handle Date string or epoch seconds
  if (typeof value === "string" || value instanceof Date) return new Date(value);
  if (typeof value === "number") return new Date(value * 1000);
  return null;
};

const BillingSuccess = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const businessId = user?.businessId;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    let mounted = true;
    let retries = 5;

    const load = async () => {
      if (!businessId) return;
      setLoading(true);
      setError("");
      try {
        const data = await subscriptionService.getSubscription(businessId);
        const sub = data?.data || data;
        if (mounted) setSubscription(sub);
        // If webhook has not populated yet, retry a few times
        if (mounted && (!sub || !sub.status) && retries > 0) {
          retries -= 1;
          setTimeout(load, 1500);
        }
      } catch (e) {
        if (mounted) setError(e.message || "Failed to fetch subscription");
      } finally {
        if (mounted) setLoading(false);
      }
    };
    load();
    return () => {
      mounted = false;
    };
  }, [businessId]);

  const sessionId = params.get("session_id");
  const periodEnd = asDate(subscription?.current_period_end);

  return (
    <div style={{ maxWidth: 720, margin: "40px auto", padding: 24 }}>
      <h2>Payment Successful</h2>
      {sessionId && <p>Session: {sessionId}</p>}
      {loading && <p>Loading subscription...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}
      {subscription && (
        <div style={{ marginTop: 16 }}>
          <p>
            <strong>Status:</strong> {subscription.status || "pending"}
          </p>
          <p>
            <strong>Plan:</strong> {subscription.planName || ""} ({subscription.recurring || ""})
          </p>
          <p>
            <strong>Amount:</strong> ${((subscription.amount || 0) / 100).toFixed(2)} {subscription.currency?.toUpperCase?.()}
          </p>
          {periodEnd && (
            <p>
              <strong>Current period end:</strong> {periodEnd.toLocaleString()}
            </p>
          )}
        </div>
      )}
      <div style={{ marginTop: 24 }}>
        <Button variant="secondary" onClick={() => navigate("/dashboard")}>Go to dashboard</Button>
      </div>
    </div>
  );
};

export default BillingSuccess; 